/**
 * Created by xiongw on 2019/3/7.
 */

export default {
    alexa: {
        tcl_assitant: "Abilita abilità - TCL Assistant",
        active_code_hint: "Immetti il codice di attivazione",
        active_code_placeholder: "Codice di attivazione",

        active_code_message: "Sulla tua TCL TV, premere Impostazioni",
        active_code_message_path: " sul telecomando, vai su 'Sistema'> 'Funziona con Alexa',",
        active_code_message_part2: "selezionare 'Accedi' o 'Ottieni codice' per ottenere il codice di attivazione.",

        active_code_message_old: "Vai a  ",
        active_code_message_path_old: "Impostazioni/Sistema/Amazon Alexa/Ottieni codice ",
        active_code_message_part2_old: "sul televisore, quindi immetti il codice.",

        active_code_error_null: "Il campo del codice non può essere vuoto",
        active_code_error_number: "Inserisci numeri",
        active_code_error_bits: "Il codice deve contenere 6 cifre",
        active_code_validate: "Attiva",
        active_code_message_wrong: "Il codice di attivazione è errato o scaduto. Richiedi un nuovo codice.",
        active_code_message_exception: "Controlla la rete e riprova.",
        check_agreements_message: "È necessario accettare tutti gli accordi per poter utilizzare TCL Assistant.",
        agreements: [
            "I agree TCL to record my voice command",
            "Accetto ",
            " di TCL.",
        ],
        privacy_policy: "l'informativa sulla privacy",

        grant_hint: "Autorizza TCL a eseguire le operazioni.",
        grant_message_success: "Autorizzazione riuscita.",
        grant_message_fail: "Autorizzazione non riuscita, immetti di nuovo il codice di attivazione.",
        grant_allow: "Consenti",

        console_welcome_prompt: "Benvenuto in TCL Alexa Console",
        empty_message: "",
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/locale/lang/it.js
// module id = null
// module chunks = 